export const ccBrand = cardBrand => {
  const brands = {
    Visa: "visa",
    "American Express": "amex",
    MasterCard: "mastercard",
    Discover: "discover",
    JCB: "jcb",
    "Diners Club": "diners-club",
    Unknown: "stripe"
  };
  return brands[cardBrand] || "stripe";
};
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("ccBrand", ccBrand);
};